import { breakpointDesktopDefault } from '@/hooks/useBreakpoint';
import { theme } from '@/styles/theme';
import { PropsWithChildren } from 'react';
import { CSSProperties } from 'styled-components';

type SecaoHomeDesktopProps = PropsWithChildren<{
  style?: CSSProperties;
}>;

export const PADDING_HORIZONTAL_SECOES_HOME = theme.spacing[8];

export const PrimeiraSecaoHomeDesktop = ({
  children,
  style,
}: SecaoHomeDesktopProps) => (
  <section
    style={{
      ...breakpointDesktopDefault,
      padding: `${theme.spacing[6]}px ${PADDING_HORIZONTAL_SECOES_HOME}px`,
      minHeight: 'auto',
    }}
  >
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        // marginTop: `-${theme.spacing[4]}px`,
        gap: theme.spacing[8],
        ...style,
      }}
    >
      {children}
    </div>
  </section>
);

export const SegundaSecaoHomeDesktop = ({
  children,
  style = {},
}: SecaoHomeDesktopProps) => (
  <section
    style={{
      marginTop: '-117px',
      ...style,
    }}
  >
    {children}
  </section>
);

export const UltimaSecaoHomeDesktop = ({
  children,
  style = {},
}: SecaoHomeDesktopProps) => (
  <section
    style={{
      ...breakpointDesktopDefault,
      padding: `${theme.spacing[6]}px ${PADDING_HORIZONTAL_SECOES_HOME}px`,
      minHeight: 'auto',
      marginTop: '-120px',
      ...style,
    }}
  >
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing[8],
        zIndex: 2,
      }}
    >
      {children}
    </div>
  </section>
);
